import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(public router: Router) { }

    canActivate(route: ActivatedRouteSnapshot): boolean {

        if (!this.isAuthenticated()) {
                this.router.navigate(['/login']);
            return false;
        }

        return true;
    }

    isAuthenticated(): boolean {
        let jwtHelper = this.getJwtHelper();

        return jwtHelper.tokenGetter() != null && !jwtHelper.isTokenExpired();
    }

    getJwtHelper(): JwtHelperService {
        return new JwtHelperService({
            tokenGetter: () => {
                    return localStorage.getItem('token');
            }
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/auth-guard.service.ts